import styled from 'styled-components'
import { COLORS } from 'components/reusables/DesignConstants'
import { zoomSyncAlertPulse } from '../styled'

export const Title = styled.div`
  color: #213f68;
  font-size: 16px;
  font-weight: 700;
`

export const Course = styled.div`
  color: #757575;
  font-size: 14px;
  font-weight: 400;
`

export const DateTimeContainer = styled.p`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 400;
  color: #363636;
`

export const Separator = styled.span`
  color: #363636;
  margin: 0 4px;
`

export const DateTimeText = styled.span`
  display: inline-block;
`

/** Columna: fila de alerta Zoom a ancho completo + fila de acciones. */
export const MobileActionsStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

/** Misma paleta que ZoomSyncAlertButton (desktop), ancho 100% en móvil. */
export const ZoomSyncAlertButtonMobile = styled.div`
  width: 100%;

  button {
    width: 100%;
    background-color: rgba(254, 169, 44, 0.12);
    border-width: 1px;
    border-color: rgba(254, 169, 44, 0.5);
    border-radius: 8px;
    color: ${COLORS.secondary};
    font-size: 14px;
    animation: ${zoomSyncAlertPulse} 2.2s ease-out infinite;

    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }

    &:hover {
      background-color: rgba(254, 169, 44, 0.18) !important;
      border-color: rgba(254, 169, 44, 0.55) !important;
      color: ${COLORS.secondary} !important;
    }
    &:focus {
      background-color: rgba(254, 169, 44, 0.12) !important;
      border-color: rgba(254, 169, 44, 0.5) !important;
      color: ${COLORS.secondary} !important;
    }
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`

export const StartWebinarButton = styled.div`
  button {
    border-radius: 8px;
    font-size: 14px;
    width: 40dvi;
    height: 40px;
  }
`

export const LinksButton = styled.div`
  button {
    border-radius: 8px;
    font-size: 14px;
    font-weight: 700;
    width: 35dvi;
    height: 40px;
    background-color: #f0f0f0;
    color: #4c4c4c;
  }
`
export const SoonButton = styled.div`
  width: 100%;
  button {
    background-color: #e7f3fe;
    border-width: 1px;
    border-color: #b6dbfb;
    border-radius: 8px;
    color: #363636;
    width: 100%;

    &:hover {
      background-color: #e7f3fe !;
      border-color: #b6dbfb;
      color: inherit !important;
    }
    &:focus {
      background-color: #e7f3fe !important;
      border-color: #b6dbfb !important;
      color: inherit !important;
    }
  }
`
